// extracted by mini-css-extract-plugin
export default {"ellipsisWrap":"ellipsis-module--ellipsisWrap--GqO+U","ellipsis":"ellipsis-module--ellipsis--e4gX3","indent":"ellipsis-module--indent--aDaTi"};